import { HttpInterceptorFn } from '@angular/common/http';
import { ACCESS_TOKEN_KEY } from "@core/services/authentication.service";

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  const accessToken = localStorage.getItem(ACCESS_TOKEN_KEY);
  if (accessToken) {
    const headers =
      req.headers
        .set('Authorization', `Bearer ${accessToken}`)
    req = req.clone({ headers });
  }
  return next(req);
}
